const store = {
    // url_api:"http://localhost:3001", //api
    // url_api:"http://52.78.1.19:3001", //test
    url_api:"https://api.boomco.org"
};

export default store;


